import { CameraType } from "APP_ROOT/data/media";
export default {
  name: "camera_obscured",
  localization: {
    en: {
      title: "Camera obscured",
      settingsHeader: "Camera Obscured",
    },
    fr: {
      title: "Caméra obstruée",
      settingsHeader: "Obstruction de Caméra",
    },
  },
  proto: {
    name: "EVENT_RAVEN_CAMERA_OBSCURED",
    value: 130,
  },
  isBuiltByDefault: true,
  isBuiltEnvironmentOverride: {
    showcase: false,
  },
  visibility: {
    reports: true,
    coaching: true,
    coachingNoFacialRecognition: true,
    warning: false,
  },
  isConsumerFeature: false,
  defaultCameraType: CameraType.CAMERA_CABIN,
  showBetaDecoration: false,
};
